/* eslint-disable no-param-reassign,  @typescript-eslint/no-unused-vars, no-underscore-dangle */
import { v4 as uuidv4 } from 'uuid';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../../../services/GenesisApi';
import { IBeachCheck } from '../../../types/BeachCheck.type';
import { BEACH_CHECKS } from '../../../constants/BeachChecks';

export interface IBeachCheckState {
  loadingBeachChecks: boolean;
  beachChecks: IBeachCheck[];
  beachCheckDetails: IBeachCheck | null;
  beachCheckDetailsUnsaved: boolean;
}

export const initialState: IBeachCheckState = {
  loadingBeachChecks: false,
  beachChecks: [],
  beachCheckDetails: null,
  beachCheckDetailsUnsaved: false,
};

export const getAllBeachChecks = createAsyncThunk(
  'beachChecks/getAllBeachChecks',
  async ({ _beachCheckId }: { _beachCheckId: null | number }) => {
    return get(BEACH_CHECKS, {})
      .then((response) => {
        const data = response.data ?? [];
        return data.map((_) => ({
          ..._,
          terminals: _.terminals.map((terminal) => ({
            ...terminal,
            uniqueId: uuidv4(),
            isActive: true,
          })),
          exitPoints: _.exitPoints.map((exitPoint) => ({
            ...exitPoint,
            uniqueId: uuidv4(),
            isActive: true,
          })),
        }));
      })
      .catch((error) => {
        throw error;
      });
  }
);

const beachChecks = createSlice({
  name: 'beachChecks',
  initialState,
  reducers: {
    updateField: (state, action) => {
      if (state?.beachCheckDetails) {
        const { field, value } = action.payload;
        state.beachCheckDetails[field] = value;
      }
    },
    setBeachCheckDetails: (state, action) => {
      state.beachCheckDetails = action.payload;
      state.beachCheckDetailsUnsaved = false;
    },
    resetBeachCheckDetails: (state) => {
      state.beachCheckDetails = null;
      state.beachCheckDetailsUnsaved = false;
    },
    updateBeachCheckDetailsFormChanges: (state, action) => {
      const { value } = action.payload;
      state.beachCheckDetailsUnsaved = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllBeachChecks.pending, (state: IBeachCheckState) => {
        state.loadingBeachChecks = true;
        state.beachChecks = [];
      })
      .addCase(
        getAllBeachChecks.fulfilled,
        (state: IBeachCheckState, action) => {
          const { payload } = action;
          state.beachChecks = payload;
          state.loadingBeachChecks = false;
          if (action.meta.arg._beachCheckId) {
            state.beachCheckDetails = payload.find(
              (check) => check.beachCheckId === action.meta.arg._beachCheckId
            );
          } else {
            const [beachCheck] = payload;
            state.beachCheckDetails = beachCheck;
          }
        }
      )
      .addCase(getAllBeachChecks.rejected, (state: IBeachCheckState) => {
        state.loadingBeachChecks = false;
      });
  },
});

export const beachChecksActions = beachChecks.actions;
export default beachChecks.reducer;
